module.exports = __webpack_public_path__ + "static/media/school-stone-facade.aaf58b17.jpg";